/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetAdminRightsById$Request {
    adminId: number;
}

export interface GetAdminRightsById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdminRightsByIdRequest = createAction<PayloadData<void, GetAdminRightsById$Request>>('GET_ADMIN_RIGHTS_BY_ID__GET_ADMIN_RIGHTS_BY_ID__REQUEST');
export const getAdminRightsByIdSuccess = createAction<PayloadData<Array<string>, GetAdminRightsById$Request>>('GET_ADMIN_RIGHTS_BY_ID__GET_ADMIN_RIGHTS_BY_ID__SUCCESS');
export const getAdminRightsByIdFailure = createAction<PayloadData<Error, GetAdminRightsById$Request, true>>('GET_ADMIN_RIGHTS_BY_ID__GET_ADMIN_RIGHTS_BY_ID__FAILURE');

export const getAdminRightsByIdActions = [
    getAdminRightsByIdRequest,
    getAdminRightsByIdSuccess,
    getAdminRightsByIdFailure
] as const;

/**
 * @param {number} meta.adminId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdminRightsById = (meta: GetAdminRightsById$Request, config?: GetAdminRightsById$Config) => {
    return {
        CALL_API: {
            types: getAdminRightsByIdActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admins/${meta.adminId}/access-rights`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

